import styled from 'styled-components';

export const StyledClose = styled.div`
  width: 24px;
  height: 24px;
  position: absolute;
  top: -12px;
  right: -12px;
`;
